
import React, { useState } from 'react';
import "./Login.css"
const LoginForm = ({companyLogo, setPassword, setUser, password, user, navigateToModules,signInProcess}) => {
const [showPassword,setShowPassword]=useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    navigateToModules()
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
         <div className="input-group password-group">
              <input
               type="text"
               id="employeeCode"
               placeholder="Employee Code"
               value={user}
               onChange={(e) => setUser(e.target.value)}
               
                className="input-field"
              />
            
            </div>
    
       <div className="input-group password-group">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="toggle-password"
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                )}
              </button>
            </div>
      
      <div className="forgot-password">
        {/* <a href="#">Forgot Password ?</a> */}
      </div>
      
      <button 
      disabled={signInProcess}
      type="submit"
       className="submit-button" >
       {signInProcess ? "Signing In..." : "Sign In"}
      </button>
    </form>
  );
};

export default LoginForm;